<template>
  <div class="auth">
      <div class="container">
          <div class="auth__inner">
              <div class="auth__head">
                  <div class="auth__preview">
                      <img src="/static/img/logo-color.svg" alt="logo" class="auth__preview__img">
                  </div>
              </div>
              <form class="auth__body" @submit.prevent="login">
                  <div class="auth__body__main">
                      <h2 class="auth__title">Login Form</h2>
                      <p class="auth__desc">Please fill all fields</p>

                      <div class="auth__form">
                          <div class="auth__form__block auth__form__block--fullw">
                              <input type="text" class="input-default" placeholder="Login or Email Address" required v-model="username">
                          </div>
                          <div class="auth__form__block auth__form__block--fullw">
                              <input type="password" class="input-default" placeholder="Password" required v-model="password">
                          </div>

                          <div class="auth__form__links">
                              <router-link class="auth__form__links__item" to="/forgot">Forgot passowrd</router-link>
                              <router-link class="auth__form__links__item" to="/signup">Don’t have account</router-link>
                          </div>
                      </div>
                  </div>

                  <div class="auth__body__controls">
                      <button type="submit" class="button button--primary">login</button>
                      <router-link class="button button--secondary-otln" to="/">Back to site</router-link>
                  </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import {AUTH_REQUEST} from '../store/actions/auth'
import store from '../store'
import hub from '../utils/event'
import Swal from 'sweetalert2'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        success: false,
        error: false,
        ernum: localStorage.getItem('user-error')
      },
      username: '',
      password: '',
      usertype: 'advertiser',
      showFormAlert: false
    }
  },
  methods: {
    login: function () {
      const { username, password, usertype } = this
      this.$store.dispatch(AUTH_REQUEST, { username, password, usertype }).then(() => {
        localStorage.removeItem('user-error')
        this.$store.dispatch('getProfile')
        hub.$emit('login', '')
        this.$router.push('/advertiser/')
      }).catch(ErrorEvent => {
        console.log(store)
        if (store.getters.authStatus) {
          this.form.ernum++
          localStorage.setItem('user-error', this.form.ernum)
          if (this.form.ernum >= 3) {
            alert('Внимание после 5-й попытки ваш ip будет заблокирован!')
          }
          this.form.error = store.getters.authStatus
          Swal('Error!', 'Wrong login/pass', 'Warning')
        }
      })
    }
  }
}
</script>

<style scoped>
.login{
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue